import { defineStore } from 'pinia';
import api from '@/api/api';
import type {ZLegal} from "@schemas/legal.schemas";
import type {LegalType} from "@typesDef/legal.types";
import {useUserStore} from "@/stores/user";

// FIXME issue after accepting, the user data is not updated => so if you go to account afterwards,
//  you will see that the legal terms are not accepted, even though they are.
//  This is because the user data is not updated after accepting the legal terms. We need to update the user data after accepting the legal terms,
//  so that the user data is up to date and the legal terms are accepted in the user data.

export const useLegalStore = defineStore('legal', {
    state: () => ({
        legalInfo: null as ZLegal | null,
        currentLegal: null as ZLegal | null,
    }),
    getters: {
        getLegalInfoByType: (state) => (legalType: LegalType): ZLegal | null  =>{
            log.debug(`getLegalInfoByType(${legalType??""})`);
            if (!state.legalInfo || !legalType) {
                return null;
            }
            const termObj = state.legalInfo[legalType]??{}
            const response = {
                type: legalType,
               ...termObj
            }

            return response ?? null;
        }
    },
    actions: {
        clearMyData(): void {
            this.currentLegal = null;
            this.legalInfo = null;
        },
        async fetchLegalInfo(): Promise<ZLegal[]> {
            if(!this.legalInfo) {
                this.legalInfo = await api.getDocument<ZLegal>('legal', '');
            }
            return this.legalInfo;
        },
        async fetchCurrentLegal(): Promise<ZLegal> {
            if (!this.currentLegal) {
                this.currentLegal = await api.getDocument<ZLegal>('legal', 'current');
            }
            return this.currentLegal;
        },
        async acceptLegal(legalType: LegalType): Promise<ZLegal> {
            const updatedLegal = await api.postDocument<ZLegal>('legal/accept', {
                term: legalType,
            });
            this.currentLegal = updatedLegal;

            // Keep user and legal stores in sync because legal is part of the user entity.
            const userStore = useUserStore();
            if (userStore.myUserId) {
                const myUser = userStore.usersById[userStore.myUserId];
                if (myUser) {
                    userStore.usersById[userStore.myUserId] = {
                        ...myUser,
                        legal: {
                            ...(myUser.legal ?? {}),
                            ...((updatedLegal as any).accepted ?? {}),
                        },
                    };
                }
            }

            return updatedLegal;
        }
    }
});
